




























































































































































































import {
  createComponent,
  provide,
  inject,
  onMounted,
  computed,
  reactive,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import WalletKey from "@/components/wallet-key";
import arrowSvg from "@/assets/svg/arrow.svg";
import _ from "lodash";
import Filters from "@/lib/filters";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const walletStore = inject(WalletKey);
    if (!walletStore) {
      throw new Error(`${WalletKey} is not provided`);
    }

    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);

    const query = computed(() => context.root.$route.query);

    const walletList = computed(() => walletStore.walletList);
    const walletHistoryList = computed(() => walletStore.walletHistoryList);
    const companyCodeToTotalTransactionMap = computed(
      () => walletStore.companyCodeToTotalTransactionMap
    );

    const targetYear = computed(() => walletStore.targetYear);

    const currentYear = new Date().getFullYear();
    const yearList: [number] = _.range(currentYear, currentYear - 3, -1);
    const monthList: [number] = _.map(_.range(12, 0, -1), (item: number) =>
      String(item).padStart(2, "0")
    );
    const currentMonthformat = Filters.formatMonth(new Date());

    const setCarouselFlag = ref<boolean>(false);
    const carouselIndex = ref<number>(0);
    const slideIndex = ref<number>(0);
    const yenFormat = new Intl.NumberFormat("ja-JP", {
      style: "currency",
      currency: "JPY"
    });

    const setSlideIndex = (year: number) => {
      displayuiStore.openOverlayLoading();
      setCarouselFlag.value = false;
      slideIndex.value = currentYear - year;
      walletStore.inputTargetYear(year);
      walletStore.clearWalletHistoryList();
      walletStore.clearCompanyCodeToTotalTransactionMap();
      let promisList = walletStore.getWalletHistoryList();
      Promise.all(promisList)
        .then(results => {
          walletStore.updateCompanyCodeToTotalTransactionMap();
          displayuiStore.closeOverlayLoading();
          setCarouselFlag.value = true;
        })
        .catch(reject => {
          context.root.$router.push({ name: "MemberHome" });
        });
    };

    const setCarouselIndex = (code: string) => {
      carouselIndex.value = _.findKey(walletList.value, {
        company_code_item: { internal_value: code }
      })
        ? Number(
            _.findKey(walletList.value, {
              company_code_item: { internal_value: code }
            })
          )
        : 0;
    };

    onMounted(async () => {
      displayuiStore.openOverlayLoading();
      walletStore.setAuthorizationHeader(accessToken.value);

      await walletStore.getWalletList();
      if (query.value.year) {
        walletStore.inputTargetYear(Number(query.value.year));
        setSlideIndex(Number(query.value.year));
      } else {
        setSlideIndex(currentYear);
      }
      if (query.value.code) {
        setCarouselIndex(String(query.value.code));
      }
    });

    return {
      _,
      Filters,
      targetYear,
      walletList,
      walletHistoryList,
      companyCodeToTotalTransactionMap,
      yearList,
      monthList,
      currentMonthformat,
      carouselIndex,
      slideIndex,
      setSlideIndex,
      setCarouselFlag,
      yenFormat
    };
  },
  components: {
    arrowSvg
  }
});
